

import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import { Box } from '@mui/material';

/**
 * 
 * @param {Data} param0 
 * @returns Graph which return Baseline, Previous and current recording Lead1 mediaan Graph 
 */

const MultiLineChart = ({ data }) => {
  const svgRef = useRef();

  useEffect(() => {
    if (!data || data.length === 0) return;
    const maxDataLength = Math.max(...data.map(d => d.length));
    const margin = { top: 10, right: 30, bottom: 10, left: 10 },
      width = 400 - margin.left - margin.right,
      height = 291 - margin.top - margin.bottom;

    const svg = d3.select(svgRef.current);
    svg.selectAll('*').remove();

    const g = svg
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

    const allValues = data.flat();
    const x = d3
      .scaleLinear()
      .domain([0, maxDataLength - 1])
      .range([0, width]);
    const y = d3
      .scaleLinear()
      .domain([d3.min(allValues), d3.max(allValues)])
      .range([height, 0]);

    const colors = ['#DEB56B', '#91B4A5', '#885FA5']; // Yellow, Dark Green, Light Green fixed format Baseline, Previous, Corrent)

    const line = d3
      .line()
      .x((d, i) => x(i))
      .y((d) => y(d))
      .curve(d3.curveMonotoneX);

    data.forEach((dataset, i) => {
      g.append('path')
        .datum(dataset)
        .attr('fill', 'none')
        .attr('stroke', colors[i % colors.length]) // Assign colors in order
        .attr('stroke-width', 2)
        .attr('d', line);
    });
  }, [data]);

  return (
    <Box sx={{ backgroundColor: 'white', borderRadius: '8px' }}>
      <svg ref={svgRef}></svg>
    </Box>
  );
};

export default MultiLineChart;
